import { cva } from 'class-variance-authority';
import { uiMarker } from './shared';

/**
 * SIGNATURE PAD
 *
 * A drawing surface for a signature. The bitmap it produces is paper — white
 * ground, black ink — because it is exported as a PNG that gets stored and
 * printed on a release form; so the pad sits on Surface's `paper` tone, in
 * either theme, with a dashed rule to mark it as a place to write rather
 * than a picture.
 *
 * The canvas has a fixed pixel size (that is what the export is) and is
 * scaled to the width it is given, capped at its own width so the ink does
 * not blur.
 */
export const signatureCanvasRecipe = cva([
  uiMarker,
  'block h-auto w-full cursor-crosshair touch-none',
]);
